(() => {
  const storageKey = 'poaig_attribution_v1';
  const maximumLength = 180;

  const clean = (value) => String(value || '').trim().slice(0, maximumLength);

  const analyticsAllowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed());
  };

  const readStored = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(storageKey) || '{}');
    } catch (_) {
      return {};
    }
  };

  const externalReferrer = () => {
    if (!document.referrer) return '';
    try {
      const referrer = new URL(document.referrer);
      return referrer.hostname === window.location.hostname ? '' : referrer.hostname.replace(/^www\./, '');
    } catch (_) {
      return '';
    }
  };

  const collect = () => {
    if (!analyticsAllowed()) return null;

    const parameters = new URLSearchParams(window.location.search);
    const referrer = externalReferrer();
    const incomingSource = clean(parameters.get('utm_source') || referrer || 'direct');
    const incomingMedium = clean(parameters.get('utm_medium') || (referrer ? 'referral' : 'none'));
    const incomingCampaign = clean(parameters.get('utm_campaign'));
    const hasNewTouch = parameters.has('utm_source') || parameters.has('utm_medium') || parameters.has('utm_campaign') || Boolean(referrer);
    const stored = readStored();

    if (!stored.first_source) {
      stored.first_source = incomingSource;
      stored.first_medium = incomingMedium;
      stored.first_campaign = incomingCampaign;
      stored.first_landing = clean(`${window.location.pathname}${window.location.search}`);
    }

    if (!stored.last_source || hasNewTouch) {
      stored.last_source = incomingSource;
      stored.last_medium = incomingMedium;
      stored.last_campaign = incomingCampaign;
    }

    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(stored));
    } catch (_) {
      return null;
    }
    return stored;
  };

  const fillCartAttributes = () => {
    const attribution = collect();
    if (!attribution) return;

    document.querySelectorAll('[data-poaig-attribution]').forEach((input) => {
      const value = clean(attribution[input.dataset.poaigAttribution]);
      if (!value) return;
      input.value = value;
      input.disabled = false;
    });
  };

  const initialize = () => {
    fillCartAttributes();
    window.setTimeout(fillCartAttributes, 600);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('visitorConsentCollected', fillCartAttributes);
})();
